// react
import React from "react";

// react-router-dom
import { useNavigate, useLocation } from "react-router-dom";

// context
import { UserAuth } from "context/AuthContext";

// react-i18next
import { useTranslation } from "react-i18next";

// react-flagkit
import Flag from "react-flagkit";

// @mui
import { useTheme, useMediaQuery, Grid, Box, AppBar, Toolbar, Select, MenuItem, Tooltip, IconButton, Link } from "@mui/material";
import { Login as LoginIcon } from "@mui/icons-material";

// A ---------------------------------------------------------------------- M

const Logo = () => (
  <Link href="/" sx={{ display: "flex" }}>
    <Box
      component="img"
      src="/logo/trusted-operations/logo.png"
      alt="TrustedOperations logo"
      sx={{
        maxHeight: 30,
        transform: "scale(4.5)",
        transformOrigin: "left",
      }}
    />
  </Link>
);

const LanguageOption = ({ country, label }) => (
  <Box display="flex" alignItems="center">
    <Flag country={country} style={{ marginRight: 8 }} />
    {label}
  </Box>
);

const DefaultLayout = (props) => {
  const { language, setLanguage } = UserAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const handleLanguageChange = (lng) => {
    setLanguage(lng);
  };

  const handleSignIn = () => {
    navigate("/signin");
  };

  const isDefaultable = location.pathname === "/signin" || location.pathname === "/reset-password";
  const gridItemStyle = isDefaultable ? {} : isMobile ? { p: "3%" } : { p: "1.5%" };

  return (
    <Grid container>
      <Grid item xs={12}>
        <AppBar
          position="fixed"
          elevation={0}
          sx={{
            zIndex: theme.zIndex.drawer + 1,
            background: "linear-gradient(180deg, rgba(11,11,15,0.9) 0%, rgba(5,5,8,0.98) 100%)",
            backdropFilter: "blur(10px)",
            borderBottom: "1px solid rgba(255,255,255,0.08)",
            boxShadow: "0 2px 8px rgba(0,0,0,0.4)",
          }}
        >
          <Toolbar variant="regular">
            <Logo />
            <Box sx={{ flexGrow: 1 }} />
            <Select
              value={language}
              onChange={(e) => handleLanguageChange(e.target.value)}
              variant="standard"
              disableUnderline
              sx={{
                color: "#ffffff",
                "& .MuiSvgIcon-root": { color: "#ffffff" },
              }}
            >
              <MenuItem value="it">
                <LanguageOption country="IT" label="IT" />
              </MenuItem>
              <MenuItem value="en">
                <LanguageOption country="GB" label="EN" />
              </MenuItem>
            </Select>

            {!isDefaultable && (
              <Tooltip title={t("sign_in")} placement="top">
                <IconButton color="inherit" onClick={handleSignIn}>
                  <LoginIcon />
                </IconButton>
              </Tooltip>
            )}
          </Toolbar>
        </AppBar>

        {!isDefaultable && <Toolbar />}
      </Grid>

      <Grid item xs={12} sx={gridItemStyle}>
        {props.children}
      </Grid>
    </Grid>
  );
};

export default DefaultLayout;
